<template>
  <div :ref="chartRefId" :style="{ width: '100%', height: '100%' }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'BarChartEChart2',
  props: {
    dataInput: {
      type: Array,
      required: true,
      // Example: [{ variable: 'Math', value: 85 }, { variable: 'Science', value: 92 }]
    },
    barColors: {
        type: Array,
        default: () => []
        // Example: ['#FF6B6B', '#4D96FF', '#6BCF63']
    }
  },
  data() {
    return {
      chartRefId: `bar-chart-${this._uid}`,
      chartInstance: null
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chartEl = this.$refs[this.chartRefId];
      if (!chartEl) return;

      this.chartInstance = echarts.init(chartEl);

      const categories = this.dataInput.map(d => d.variable);
      const values = this.dataInput.map(d => Number(d.value));
      const maxValue = Math.max(...values);
      const yMax = Math.ceil(maxValue * 1.2); // 20% padding
      const interval = Math.max(1, Math.ceil(yMax / 4));

      const options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            interval: 0, // show ALL labels
            formatter: function (value) {
              const maxLength = 8; // chars per line
              let result = '';
              for (let i = 0; i < value.length; i += maxLength) {
                result += value.substring(i, i + maxLength) + '\n';
              }
              return result;
            }
          }
        },
        yAxis: {
          type: 'value',
          max: yMax,
          interval: interval,
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: 'bar',
            data: values,
            barWidth: '60%',
            itemStyle: {
                color: (params) => {
                    // fallback color if array is shorter than data
                    return this.barColors[params.dataIndex] || '#5470C6'
                }
            }
          }
        ]
      };

      this.chartInstance.setOption(options);
      window.addEventListener('resize', this.resizeChart);
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    getChartInstance() {
      return this.chartInstance;
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>
